import React from 'react';

import { AllocationItem } from 'interface/allocation';

import CurrentAllocationItem from './components/CurrentAllocationItem';

import { EMPTY_ALLOCATION_CHART_MESSAGE } from 'constants/dashboard';

interface Props {
  allocations?: AllocationItem[];
  colorData?: string[];
}

const CurrentAllocation: React.FC<Props> = ({ allocations = [], colorData = [] }) => {
  return (
    <div className="allocation__project">
      {allocations.length ? (
        <div className={allocations.length === 1 ? 'allocation__centerItem' : 'allocation__projects custom-scroll-bar'}>
          {allocations.map((item, index) => (
            <CurrentAllocationItem key={item.id || index} item={item} index={index} colorData={colorData} />
          ))}
        </div>
      ) : (
        <div className="allocation__empty">
          <p>{EMPTY_ALLOCATION_CHART_MESSAGE}</p>
        </div>
      )}
    </div>
  );
};

export default CurrentAllocation;
